var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIceCream({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-ice-cream-cone",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7A5 5 0 0 0 7 7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceCream);
export default __webpack_public_path__ + "static/media/ice-cream.9226425030c8334dbf01d68d95dd0926.svg";
export { ForwardRef as ReactComponent };